import React, { useEffect, useState } from "react";
import { Brain } from "lucide-react";

const loadingMessages = [
  "Initializing HubSpot data sync",
  "Establishing secure API connection",
  "Fetching deals and contact pipelines",
  "Analyzing CRM workflows",
  "Identifying revenue bottlenecks",
  "Optimizing data for AI insights",
  "Preparing visual flow diagrams",
  "Mapping relationships between deals",
  "Detecting anomalies in revenue streams",
  "Finalizing strategic insights",
];

const themeColors = ["#F57E0C", "#FFB500", "#8B8E90"];

const AIAnalysisLoader: React.FC = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [colorIndex, setColorIndex] = useState(0);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    const messageInterval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentMessageIndex(
          (prevIndex) => (prevIndex + 1) % loadingMessages.length
        );
        setColorIndex((prevColor) => (prevColor + 1) % themeColors.length);
        setFade(true);
      }, 500);
    }, 3000);

    return () => {
      clearInterval(messageInterval);
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-lg flex items-center justify-center z-50 text-white">
      <div className="flex flex-col items-center space-y-8 animate-fade-in">
        <div className="relative flex items-center justify-center">
          <Brain
            className="w-16 h-16 animate-pulse-slow"
            style={{ color: themeColors[colorIndex] }}
            strokeWidth={1}
          />
        </div>

        <p
          className={`text-lg font-semibold text-center leading-relaxed transition-opacity duration-500 ${
            fade ? "opacity-100" : "opacity-0"
          }`}
        >
          {loadingMessages[currentMessageIndex]}
        </p>

        <div className="relative w-48 h-1 bg-gray-700 rounded-full overflow-hidden">
          <div className="absolute inset-0 animate-progress-glow bg-gradient-to-r from-transparent via-secondary to-transparent animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default AIAnalysisLoader;
